import { PRE_INIT_SESSION_ID } from './../utils/instantLoaded/constants';
import { SessionIDType } from '@/utils/constants';
import { observable, action } from 'mobx';

export interface SessionIDItem {
  type: string;
  id: string;
}

class SessionIDListStore {
  @observable sessionIDList: SessionIDItem[];

  constructor() {
    this.sessionIDList = [{
      type: SessionIDType.PRE_INIT_SESSION,
      id: PRE_INIT_SESSION_ID,
    }];
  }

  @action
  UPDATE_SESSION_ID_LIST(idItem: SessionIDItem) {
    this.sessionIDList.push(idItem);
  }
}

const sessionIDListStore = new SessionIDListStore();

export default sessionIDListStore;
